import { defineCopy } from "@tami/core/intl";

import { APP_PAGES_COPY_EN_US } from "./en-us/pages.copy";
import { APP_PAGES_COPY_ES_ES } from "./es-es/pages.copy";

/** Textos só-web de páginas soltas do `app/` (erro, 404, demo, bio, exclusão de dados). */
export const APP_PAGES_COPY_PT_BR = {
  error: {
    title: "Algo deu errado!",
    description: "Parece que nosso servidor está enfrentando um problema inesperado. 😔",
    back: "Voltar",
  },
  notFound: {
    title: "Página nâo encontrada :(",
    description: "Parece que a página que você solicitou não foi encontrada.",
    back: "Voltar",
    reload: "Recarregar",
  },
  demo: {
    title: "Demo interativa",
    description:
      "Explore a Tãmi por dentro: conteúdo, campanhas, agenda, finanças e o assistente no WhatsApp. Clique nos pontos marcados ou deixe o tour guiado mostrar tudo.",
    heading: "Demo interativa da Tãmi",
    backAria: "Voltar para o site",
    back: "Voltar",
    signUp: "Criar conta de graça",
  },
  links: {
    title: "Links",
    description:
      "Crie sua conta, veja a demo por dentro e fale com a gente: os links da Tãmi, a ferramenta que organiza a vida de creators e Collabs.",
  },
  signTagline: "Você cria. Tãmi organiza.",
  dataDeletion: {
    metaTitle: "Solicitação de exclusão de dados",
    title: "Solicitação de exclusão de dados recebida",
    received: "Sua solicitação de exclusão de dados do Instagram foi recebida e processada.",
    revokeIntro:
      "Quando você revoga o acesso da Tãmi ao seu Instagram ou solicita a exclusão dos seus dados diretamente pela Meta, apagamos imediatamente:",
    deletedConnection: "a conexão entre sua conta da Tãmi e sua conta do Instagram;",
    deletedToken: "o token de acesso associado a essa conexão;",
    deletedMetrics: "os seguidores, as publicações e as métricas do Instagram que guardávamos.",
    immediate:
      "Essa exclusão acontece assim que recebemos o pedido, sem necessidade de nenhuma ação adicional da sua parte, e nenhum novo dado é coletado do Instagram a partir desse momento. O que está no próprio Instagram não é afetado. Para voltar a acompanhar o seu desempenho na Tãmi, é só conectar a conta de novo.",
    contactBefore: "Se tiver qualquer dúvida sobre a exclusão, escreva para",
    supportEmail: "suporte@tamiapp.com",
    contactAfter: ". Respondemos em até 15 dias, como manda a LGPD.",
    questionsBefore: "Dúvidas sobre como tratamos seus dados podem ser esclarecidas na nossa",
    privacyLink: "política de privacidade",
  },
} as const;

export const APP_PAGES_COPY = defineCopy(APP_PAGES_COPY_PT_BR, {
  "en-US": APP_PAGES_COPY_EN_US,
  "es-ES": APP_PAGES_COPY_ES_ES,
});
